module.exports = __webpack_public_path__ + "img/carrousel-mamo-1.d5b64e11.jpg";